/**
 * TODO: Relocate to packages/utilities?
 *
 * Used by Http and Socket. We could have a set of variants, json and binary.
 *
 * Not going to remove this / re-locate in this PR
 */
import { DI } from '@microsoft/fast-foundation';
import { logger } from '../utils';
/**
 *  @deprecated - Use `JSONSerializer` from `@genesislcap/foundation-utils` instead.
 */
class JSONSerializer {
    /**
     * TODO: Add reviver and replacers
     */
    serialize(object) {
        logger.deprecated('serialize', 'Use `serialize` from `JSONSerializer` from `@genesislcap/foundation-utils` instead.');
        return JSON.stringify(object);
    }
    deserialize(input) {
        logger.deprecated('deserialize', 'Use `deserialize` from `JSONSerializer` from `@genesislcap/foundation-utils` instead.');
        if (!input) {
            return Promise.resolve({});
        }
        if (typeof input === 'string') {
            return JSON.parse(input);
        }
        if (input.data) {
            return JSON.parse(input.data);
        }
        return input.text().then((text) => JSON.parse(text));
    }
}
/**
 * The DI token for the Serializer interface.
 * @internal
 */
export const Serializer = DI.createInterface((x) => x.singleton(JSONSerializer));
